module.exports = __webpack_public_path__ + "img/PT48.048f5365.png";